<template>
  <div v-if="competition" class="mt-5">
    <b-row class="mb-2">
      <b-col cols=4 md=2 lg=2 class="text-right text-md-left"><b>Name</b></b-col>
      <b-col cols=8 md=4 lg=4>{{ competition.name }}</b-col>

      <b-col cols=4 md=2 lg=2 class="text-right text-md-left"><b>Testquiz</b></b-col>
      <b-col cols=8 md=4 lg=4>{{ competition.getTestQuiz().name }}</b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols=4 md=2 lg=2 class="text-right text-md-left"><b>Veröffentlicht</b></b-col>
      <b-col cols=8 md=4 lg=4>{{ competition.public ? 'ja' : 'nein' }}</b-col>

      <b-col cols=4 md=2 lg=2 class="text-right text-md-left"><b>Preise veröffentlicht</b></b-col>
      <b-col cols=8 md=4 lg=4>{{ competition.prices ? 'ja' : 'nein' }}</b-col>
    </b-row>



    <b-row class="mb-2">
      <b-col cols=4 md=2 lg=2 class="text-right text-md-left"><b>Anmeldung</b></b-col>
      <b-col cols=8 md=4 lg=4>
        {{ competition.dates.registration.start | moment('ll') }}
        -
        {{ competition.dates.registration.end | moment('ll') }}
      </b-col>

      <b-col cols=4 md=2 lg=2 class="text-right text-md-left"><b>Zahlbar bis</b></b-col>
      <b-col cols=8 md=4 lg=4>{{ competition.dates.payment | moment('ll') }}</b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols=4 md=2 lg=2 class="text-right text-md-left"><b>Online</b></b-col>
      <b-col cols=8 md=4 lg=4>
        {{ competition.dates.online.start | moment('ll') }}
        bis
        {{ competition.dates.online.end | moment('ll') }}
      </b-col>

      <b-col cols=4 md=2 lg=2 class="text-right text-md-left"><b>Papier</b></b-col>
      <b-col cols=8 md=4 lg=4 v-if="competition.paperDatesAsOnline()">wie online</b-col>

      <b-col cols=8 md=4 lg=4 v-else>
        {{ competition.dates.paper.start | moment('ll') }}
        bis
        {{ competition.dates.paper.end | moment('ll') }}
      </b-col>


    </b-row>

    <b-row class="mb-2">
      <b-col cols=4 md=2 lg=2 class="text-right text-md-left"><b>Transfer</b></b-col>
      <b-col cols=8 md=4 lg=4>
        bis {{ competition.dates.transfer | moment('ll') }}
      </b-col>

      <b-col cols=4 md=2 lg=2 class="text-right text-md-left"><b>Kosten</b></b-col>
      <b-col cols=8 md=4 lg=4>{{ competition.costs.price }} {{ competition.costs.currency }}</b-col>
    </b-row>

  </div>
</template>
<script>
require('moment')
export default {
  name: 'ShowCompetitionDetails',
  props: ['competition']
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/admin/ShowDetails.vue